module.exports = __webpack_public_path__ + "img/password.c0f89c96.svg";